<template>
  <div class="tpp-field">
    <label>Prioridad</label>
    <div class="tpp-options">
      <label
        v-for="option in options"
        :key="option.value"
        class="tpp-option"
        :class="{ 'tpp-option--selected': value === option.value, 'tpp-option--blocked': isBlocked(option.value) }"
      >
        <input
          type="radio"
          name="ticket-priority"
          :value="option.value"
          :checked="value === option.value"
          :disabled="isBlocked(option.value)"
          @change="$emit('input', option.value)"
        />
        <span class="tpp-option-title">{{ option.label }}</span>
        <span class="tpp-option-help">{{ option.help }}</span>
      </label>
    </div>
    <p v-if="highBlockedReason" class="tpp-blocked">{{ highBlockedReason }}</p>
    <p v-else-if="quota" class="tpp-quota">
      Prioridad alta usada este mes: {{ quota.high_priority_used }} de {{ quota.high_priority_limit }}.
    </p>
  </div>
</template>

<script>
import {
  PRIORITY_LABELS,
  TICKET_PRIORITY_HIGH,
  TICKET_PRIORITY_LOW,
  TICKET_PRIORITY_MEDIUM,
} from '@/utils/ticketStates';

const OPTIONS = [
  { value: TICKET_PRIORITY_HIGH, label: PRIORITY_LABELS[TICKET_PRIORITY_HIGH], help: 'Frena la operación' },
  { value: TICKET_PRIORITY_MEDIUM, label: PRIORITY_LABELS[TICKET_PRIORITY_MEDIUM], help: 'Hay que resolverlo pronto' },
  { value: TICKET_PRIORITY_LOW, label: PRIORITY_LABELS[TICKET_PRIORITY_LOW], help: 'Puede esperar' },
];

export default {
  name: 'TicketPriorityPicker',
  props: {
    value: { type: String, default: TICKET_PRIORITY_MEDIUM },
    quota: { type: Object, default: null },
  },
  data() {
    return { options: OPTIONS };
  },
  computed: {
    highBlockedReason() {
      return this.quota && !this.quota.is_high_priority_available ? this.quota.blocked_reason : '';
    },
  },
  watch: {
    highBlockedReason(reason) {
      if (reason && this.value === TICKET_PRIORITY_HIGH) {
        this.$emit('input', TICKET_PRIORITY_MEDIUM);
      }
    },
  },
  methods: {
    isBlocked(priority) {
      return priority === TICKET_PRIORITY_HIGH && !!this.highBlockedReason;
    },
  },
};
</script>

<style scoped>
.tpp-field { margin-bottom: 16px; }
.tpp-field > label {
  font-weight: 600;
  font-size: 12.5px;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}
.tpp-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
@media (max-width: 520px) {
  .tpp-options { grid-template-columns: 1fr; }
}
.tpp-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid #d9dedb;
  border-radius: 10px;
  cursor: pointer;
}
.tpp-option input { display: none; }
.tpp-option--selected {
  border-color: #01662E;
  background: #e6f4ec;
}
.tpp-option--blocked {
  opacity: 0.55;
  cursor: not-allowed;
  background: #f4f5f4;
}
.tpp-option-title { font-weight: 700; font-size: 14px; color: #1f2937; }
.tpp-option-help { font-size: 12px; color: #6b7280; }
.tpp-blocked {
  margin: 8px 0 0;
  font-size: 12.5px;
  color: #b45309;
}
.tpp-quota {
  margin: 8px 0 0;
  font-size: 12px;
  color: #6b7280;
}
</style>
